// extracted by mini-css-extract-plugin
export default {"wrapper":"ProductCard_wrapper__UfnlS","content":"ProductCard_content__xHc0L","price":"ProductCard_price__-kVs4","product-image":"ProductCard_product-image__ZUpUK"};